import {
  GridApi,
  IStatusPanelComp,
  IStatusPanelParams,
} from '@ag-grid-community/core'
import { loadTemplate } from '@ag-grid-community/core/dist/cjs/utils/dom'
import { formatBytes, getResponseSize } from '../devtools-http-utils'

const template = `
  <span class="hs-status-bar">
    <span class="ml-2">Max Size: </span> <span class="ml-1" id="max-size-value">0</span>
    <span class="ml-2">Avg Size: </span> <span class="ml-1" id="avg-size-value">0</span>
    <span class="ml-2">Total Size: </span> <span class="ml-1" id="total-size-value">0</span>
  </span>
`

export class HttpSizeStatusBar implements IStatusPanelComp {
  private api!: GridApi
  private guiElement!: HTMLElement

  /** @internal */
  readonly listener = () => this.onRowDataUpdated()

  init(params: IStatusPanelParams): void {
    this.api = params.api
    params.api.addEventListener('rowDataUpdated', this.listener)
  }

  destroy() {
    this.api.removeEventListener('rowDataUpdated', this.listener)
  }

  getGui(): HTMLElement {
    const el = loadTemplate(template)
    this.guiElement = el
    return el
  }

  /** @internal */
  onRowDataUpdated() {
    let maxSize = 0
    let avgSize = 0
    let totalSize = 0
    let numOfSizes = 0

    this.api.forEachNode(node => {
      const size: number | undefined = getResponseSize(node.data.response)
      if (size != null) {
        numOfSizes++
        totalSize += size
        if (size > maxSize) maxSize = size
      }
    })

    if (numOfSizes > 0) avgSize = Math.round(totalSize / numOfSizes)

    const maxSpan = this.guiElement.querySelector(
      '#max-size-value',
    ) as HTMLElement
    maxSpan.innerText = `${formatBytes(maxSize)}`

    const avgSpan = this.guiElement.querySelector(
      '#avg-size-value',
    ) as HTMLElement
    avgSpan.innerText = `${formatBytes(avgSize)}`

    const totalSpan = this.guiElement.querySelector(
      '#total-size-value',
    ) as HTMLElement
    totalSpan.innerText = `${formatBytes(totalSize)}`
  }
}
